import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { useSelector } from "react-redux";
import { selectgroups } from "../../redux/businessSlice";
import ReactQuill from "react-quill"; // Import React Quill
import "react-quill/dist/quill.snow.css"; // Import the styles for the editor
import Autogooglecomplete from "../Autogooglecomplete";
import AddAdditionalFields from "../AddAdditionalField";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 800,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  overflow: "auto",
  maxHeight: "90vh",
};

export function EditBranches({
  handleCheckboxChange,
  origin,
  nodeData,
  handleClose,
  open,
  handleChange,
  errors,
  handleSubmit,
  handelDirector,
  handleShareHolders,
  handelAddShareHolder,
  handleAddDirector,
  handleTotalSharesChange,
  enrichedOrganizations,
  allorganization1,
  setSharedata,
  sharedata,
  setNodeData,
  deleteJoint,
  handleJointChange,
  handleCheckbox,
  handleAddShareCompany,
}) {
  // const StyledPaper = styled(Paper)(({ theme }) => ({
  //   padding: theme.spacing(2),
  //   textAlign: "center",
  // }));
  // console.log("nodeddatat====>", nodeData)
  // const allorganization = useSelector(selectnodess);
  const [childerns, setchilderns] = useState([]);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const groups = useSelector(selectgroups);

  // useEffect(() => {
  //   const mainorganization = allorganization.filter(
  //     (item) => item.isBranch === false
  //   );
  //   const parents = mainorganization?.map((org) => {
  //     return {
  //       label: org.data.label,
  //       value: org.id.toString(),
  //     };
  //   });
  //   setParentOptions(parents);
  // }, [allorganization]);
  useEffect(() => {
    const data = enrichedOrganizations?.find(
      (item) => item.id === nodeData.nodeId
    );
    setchilderns(data);
  }, [enrichedOrganizations]);
  useEffect(() => {
    const data = enrichedOrganizations?.find(
      (item) => item.id === nodeData.nodeId
    );
    setchilderns(data);
  }, [enrichedOrganizations, childerns]);
  // const deleteDirectors = (index) => {
  //   setNodeData((prev) => ({
  //     ...prev,
  //     directors: prev.directors.filter((_, i) => i !== index),
  //   }));
  // };
  // useEffect(() => {
  //   const newCombinedData = childerns?.data?.shareHolders?.map((shareholder) => {
  //     const enrichedOrg = allorganization1.find(
  //       (org) => org.id === shareholder.childId
  //     );
  //     return {
  //       ...shareholder,
  //       companyName: enrichedOrg
  //         ? enrichedOrg.data.companyName
  //         : "Unknown Company",
  //     };
  //   });
  //   setnewdata(newCombinedData);
  // }, [allorganization1, childerns]);
  useEffect(() => {
    const total = nodeData.shareHolders.reduce(
      (acc, item) => acc + parseFloat(item.numberSharesOwned || 0),
      0
    );
    setSharedata(nodeData.totalNoOfShares - total);
  }, [nodeData]);
  // const deleteShareholder = (index) => {
  //   setNodeData((prev) => ({
  //     ...prev,
  //     shareHolders: prev.shareHolders.filter((_, i) => i !== index),
  //   }));
  // };
  // const handleCheckboxChange = (index) => {
  //     const updatedBranches = [...nodeData.Branches];
  //     updatedBranches[index].checked = !updatedBranches[index].checked; // Toggle checkbox state
  //     setNodeData((prevData) => ({ ...prevData, Branches: updatedBranches }));
  //   };
  // const handleShareHolderChange = (index, field, value) => {
  //   let updatedShareHolders = [...nodeData.shareHolders];
  //   updatedShareHolders[index] = {
  //     ...updatedShareHolders[index],
  //     [field]: value,
  //   };

  //   if (field === "numberSharesOwned" && nodeData.totalNoOfShares > 0) {
  //     updatedShareHolders[index].PercentageOfShares =
  //       (value / nodeData.totalNoOfShares) * 100;
  //   }

  //   setNodeData((prev) => ({ ...prev, shareHolders: updatedShareHolders }));
  // };
  // useEffect(() => {
  //   const data = parentOptions.filter(
  //     (item) => item.label !== nodeData.companyName
  //   );
  //   setParent(data);
  // }, [parentOptions]);
  const handleCancel = () => {
    setShowWarningModal(true);
  };
  const handleConfirmClose = () => {
    setShowWarningModal(false);
    handleClose();
  };
  // console.log(nodeData, "this is node data");

  const handleRemarksChange = (value) => {
    setNodeData((prevData) => ({
      ...prevData,
      Remarks: value, // Update Remarks in state
    }));
  };
  const handleCheck = (event) => {
    const isChecked = event.target.checked; // Get the checkbox state
    setNodeData((prev) => ({
      ...prev,
      branch: isChecked, // Update the checked value in nodeData
    }));
  };
  return (
    <React.Fragment>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        BackdropProps={{
          style: { zIndex: 0 },
        }}
        sx={{ zIndex: 1000 }}
      >
        <Box className="shadow border rounded" sx={style}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <Grid container spacing={2} sx={{ p: 3 }}>
            {/* Left column - Company related fields */}
            <Grid item xs={12}>
              <TextField
                label="Branch Name"
                name="companyName"
                id="outlined-basic"
                value={nodeData.companyName}
                onChange={handleChange}
                error={Boolean(errors?.general?.companyName)}
                fullWidth
                helperText={errors?.general?.companyName}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autogooglecomplete setNodeData={setNodeData} errors={errors} nodeData={nodeData} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl
                fullWidth
                size="small"
                variant="outlined"
                error={Boolean(errors?.general?.BusinessNature)}
              >
                <InputLabel>Business Groups</InputLabel>
                <Select
                  name="BusinessGroup"
                  value={nodeData.BusinessGroup}
                  onChange={handleChange}
                  label="Business Groups"
                >
                  {groups?.map((item, index) => {
                    return (
                      <MenuItem key={index} value={item._id}>
                        {item?.businessNature?.charAt(0)?.toUpperCase() + item?.businessNature?.slice(1)}
                      </MenuItem>
                    );
                  })}
                </Select>
                {errors?.general?.BusinessGroup && (
                  <small style={{ color: "red" }}>
                    {errors?.general?.BusinessGroup}
                  </small>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Office / Branch Manager"
                name="ManagingDirector"
                id="outlined-basic"
                value={nodeData.ManagingDirector}
                onChange={handleChange}
                error={Boolean(errors?.general?.ManagingDirector)}
                fullWidth
                helperText={errors?.general?.ManagingDirector}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Registered Address"
                name="Address"
                id="outlined-basic"
                value={nodeData?.Address}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={nodeData.branch}
                    onChange={handleCheck}
                    color="primary"
                    name="Incorporate In Progress"
                  />
                }
                label="Status: Incorporate In Progress/To be Liquidated"
              />
            </Grid>
            <Grid item xs={12} container sx={{ mb: 8 }}>
              <ReactQuill
                value={nodeData.Remarks || ""} // Bind value to state, ensure it's a string
                onChange={handleRemarksChange} // Update state on change
                modules={{
                  toolbar: [
                    // Headers and font size
                    [
                      { header: "1" },
                      { header: "2" },
                      { font: [] },
                      { size: [] },
                    ],
                    // Text formatting
                    ["bold", "italic", "underline", "strike", "blockquote"],
                    // Lists and alignment
                    [{ list: "ordered" }, { list: "bullet" }, { align: [] }],
                    // Color and background color
                    [{ color: [] }, { background: [] }],
                    // Links and clear formatting
                    ["link"],
                    ["clean"], // Clear formatting
                  ],
                }}
                placeholder="Enter remarks here..."
                style={{
                  width: "100%", // Takes full width of the container
                  height: "200px", // Custom height
                }}
              />
            </Grid>
            <Grid sx={{ marginTop: "10px", marginBottom: "10px" }} item xs={12}>
              <AddAdditionalFields nodeData={nodeData} setNodeData={setNodeData} errors={errors} />
            </Grid>
            <Grid item xs={12} container justifyContent="space-between">
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
              >
                Save
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      {showWarningModal && (
        <div
          className="modal-backdrop fade show"
          style={{ zIndex: 1200 }}
          onClick={() => setShowWarningModal(false)}
        />
      )}
      {showWarningModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="warningModalLabel"
          aria-hidden="true"
          style={{ zIndex: 1300 }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header text-center">
                <h5 className="text-center" id="warningModalLabel">
                  Warning
                </h5>
              </div>
              <div className="modal-body text-center">
                ALL ENTERED DATA WILL BE DELETED IF YOU CLOSE THIS WINDOW
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowWarningModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleConfirmClose}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}
